import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
  currentModule: string;
  onModuleChange: (module: string) => void;
}
export function Layout({
  children,
  currentModule,
  onModuleChange
}: LayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  // Close mobile sidebar on module change
  useEffect(() => {
    setIsMobileSidebarOpen(false);
  }, [currentModule]);
  // Close mobile sidebar on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Prevent body scroll when mobile sidebar is open
  useEffect(() => {
    if (isMobileSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileSidebarOpen]);
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900" data-id="element-158">
      {/* Mobile overlay */}
      {isMobileSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileSidebarOpen(false)} data-id="element-159" />}

      {/* Sidebar - hidden on mobile unless open */}
      <div className={`
        fixed inset-y-0 left-0 z-50 md:z-30
        transform transition-all duration-300 ease-in-out
        ${isMobileSidebarOpen ? 'translate-x-0 opacity-100 visible' : '-translate-x-full opacity-0 invisible'}
        md:translate-x-0 md:opacity-100 md:visible
      `} data-id="element-160">
        <Sidebar currentModule={currentModule} onModuleChange={module => {
        onModuleChange(module);
        setIsMobileSidebarOpen(false);
      }} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} onMobileClose={() => setIsMobileSidebarOpen(false)} data-id="element-161" />
      </div>

      <Header isCollapsed={isSidebarCollapsed} onMobileMenuToggle={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)} data-id="element-162" />
      <main className={`pt-16 min-h-screen transition-all duration-300 ease-in-out
          ml-0
          ${isSidebarCollapsed ? 'md:ml-[68px]' : 'md:ml-64'}
        `} data-id="element-163">
        <div className="p-3 sm:p-4 md:p-6" data-id="element-164">{children}</div>
      </main>
    </div>;
}